import type { User } from '../types';

/**
 * The parts of the portal a person may open. The superadmin sets them per
 * account; the API refuses a menu that is not in the list, so hiding one here
 * is a courtesy — the lock is on the server.
 */
export const MENUS = [
  { key: 'overview', label: 'Overview' },
  { key: 'rt-logs', label: 'RT Logs' },
  { key: 'documents', label: 'Documents' },
  { key: 'ai', label: 'Ask AI' },
  { key: 'knowledge', label: 'Knowledge Base' },
] as const;

export type MenuKey = (typeof MENUS)[number]['key'];

/**
 * Whether the user may open a menu. A superadmin opens everything; a user
 * without a list — the in-process mock — is not restricted.
 */
export function mayOpen(user: User | null | undefined, menu: MenuKey): boolean {
  if (!user) return false;
  if (user.role === 'superadmin' || !user.menus) return true;
  return user.menus.includes(menu);
}
